import { render, staticRenderFns } from "./HomeFooter2.vue?vue&type=template&id=2bbf558e&scoped=true"
import script from "./HomeFooter2.vue?vue&type=script&lang=js"
export * from "./HomeFooter2.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter2.vue?vue&type=style&index=0&id=2bbf558e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf558e",
  null
  
)

export default component.exports